import { Get } from 'config/apiServiceConfig'
import apiServices from 'config/apiServiceApiGateway'
import {
  DynamicChannelBackgroundColorsType,
  PostPutDynamicChannelPayloadType,
} from 'features/CategoryAndPosisi/@types/DynamicChannelAddEdit'
import { type LocationType } from 'utils/apiList/dynamicChannel'
import { ProductHighlightLabelEnum } from '../@types/DynamicChannelAddEdit'

const { Get: GetKong, Post, Put } = apiServices

type GetBannerListResponseType = {
  content: {
    banner_id: number
    banner_name: string
    banner_image: string
    banner_url: string
    banner_date_start: number
    banner_date_end: number
    url_image: string
  }[]
}

export type BannerHighlightPayloadType = {
  id?: number
  category_id: number
  position: number
  hubs: number[]
  start_date: number
  end_date: number
  banner_category_highlight_image: Nullable<{
    url_large: string
    url_medium: string
    url_small: string
  }>
  is_active: boolean
  is_deleted: boolean
}

export type ProductHighlightPayloadType = {
  id?: number
  product_id: number
  position: number
  label_type: ProductHighlightLabelEnum
  hubs: number[]
  default_text: string
  free_text: string
  start_date: number
  end_date: number
  is_active: boolean
  is_deleted: boolean
}

export type CreateDynamicChannelResponseType = {
  dynamic_channel_id: number
}

export const getBannerList = ({ params }: { params: { name: string; pageSize: number } }) =>
  Get<GetBannerListResponseType>({ url: '/api/banner', params })

type CategoryType = {
  id: number
  name: string
}

type BannerCategoryHighlightType = {
  id: number
  category_id: number
  position: number
  hubs: LocationType[]
  start_date: number
  end_date: number
  highlight_image: {
    url_large: string
    url_medium: string
    url_small: string
    id: number
    category_highlight_id: number
  }
  is_active: boolean
  is_deleted: boolean
}

export type GetDynamicChannelDetailResponseType = {
  data: {
    id: number
    title: string
    bg_color: DynamicChannelBackgroundColorsType
    image_url: string
    end_date: number
    start_date: number
    is_active: boolean
    product_category_highlights: []
    dynamic_channel_type: {
      id: number
      name: string
    }

    banners: {
      position: number
      slot: number
      name: string
      banner_id: number
      url_image: string
      url: string
      start_date: number
      end_date: number
      targeting_type_name: string
      segment_users: string[]
    }[]

    hubs: {
      id: number
      name: string
    }[]
    dynamic_channel_section: {
      id: number
      name: string
    }
    banner_category_highlights: BannerCategoryHighlightType[]
    category: CategoryType[]
    catalogue?: CategoryType
    logic: {
      id: number
      name: string
    }
    targeting_type: {
      targeted_user_ids: number[]
      targeted_segmentations: {
        id: number
        type_id: number
        segment_type_id: number
      }[]
      dynamic_channel_id: number
      targeting_type: number
    }
  }
  error: {
    status: false
    message: ''
    code: 0
  }
}
export const getDynamicChannelDetail = ({ dynamicChannelId }: { dynamicChannelId: string }) =>
  GetKong<GetDynamicChannelDetailResponseType, true>({
    url: `/browse/internal/v1/dynamic-channel/${dynamicChannelId}`,
  })

export type PostCreateDynamicChannelRequestType = { payload: PostPutDynamicChannelPayloadType }

export type PostCreateDynamicChannelResponseType = {
  data: {
    dynamic_channel_id: number
  }
  error: {
    message: string
    status: boolean
    code: number
  }
}
export const postCreateDynamicChannel = ({ payload }: PostCreateDynamicChannelRequestType) =>
  Post<PostCreateDynamicChannelResponseType, true>({
    url: '/browse/internal/v1/dynamic-channel',
    data: payload,
  })

export type PutUpdateDynamicChannelRequestType = {
  dynamic_channel_id: number
  payload: PostPutDynamicChannelPayloadType
}

export type PutUpdateDynamicChannelResponseType = {
  error: {
    code: number
    status: boolean
    message: string
  }
  data: {
    dynamic_channel_id: number
  }
}

export const putUpdateDynamicChannel = (request: PutUpdateDynamicChannelRequestType) =>
  Put<PutUpdateDynamicChannelResponseType, true>({
    url: `/browse/internal/v1/dynamic-channel/${request.dynamic_channel_id}`,
    data: request,
  })
